import {Component, OnInit, OnDestroy} from '@angular/core';
import {UntypedFormBuilder, FormArray, Validators, UntypedFormGroup, FormControl} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import * as moment from 'moment';
import {SharedService} from '../../shared.service';
import {CitytownService} from '../../../modules/systemconfig/citytown/citytown.service';
import {DistrictService} from '../../../modules/systemconfig/district/district.service';
import {OrganizationService} from '../../../modules/systemconfig/organization/organization.service';
import {ClassesService} from '../../../modules/academics/classes/classes.service';
import {StudentsService} from '../../../modules/students/student/student.service'
import {RelationshipService} from '../../../modules/systemconfig/relationship/relationship.service';
import {ReligionService} from '../../../modules/systemconfig/religion/religion.service';
import {NationalityService} from '../../../modules/systemconfig/nationality/nationality.service';


@Component({
  selector: 'app-tens_parent_registration',
  templateUrl: '../pages/tens_parent_registration.component.html'
})

export class TensParentRegistrationComponent implements OnInit, OnDestroy {


 RegistrationForm:UntypedFormGroup = this.fb.group({ 

      parent_image: [''],
      guardian_name: ['',Validators.required],
      guardian_mobile_no: ['',Validators.required],
      parent_email_id: [''],
      parent_contact_number: [''],
      parent_address: [''],
      parent_dob: [''],
      parent_relation_id:[''],
      parent_nationality_id:[''],
      parent_district:[''],
      parent_city:[''],
      parent_zipcode:[''],
      parent_state: [''],

      student_image: [''],
      student_fullname: [''],
      student_first_name: ['', Validators.required],
      student_middle_name: [''],
      student_last_name: [''],
      reg_no: [''],
      date_of_registration: ['', Validators.required],
      student_class: ['', Validators.required],
      student_division: ['', Validators.required],
      student_dob: ['', Validators.required],
      student_gender: ['',Validators.required],
      student_blood_group : [''],
      student_nationality_id : ['',Validators.required],
      place_of_birth: [''],
      place_of_birth_country: [''],
      student_religion_id : [''],
      identity_mark:[''],
      admission_date:[''],
      passport_number:[''],
      passport_expiry_date: ['',Validators.required],
      passport_date_of_issue: ['',Validators.required],
      passport_place_of_issue:[''],
      emirates_id_number: [''],
      emirates_expiry_date: ['',Validators.required],
      residence_visa_number: [''],
      residence_visa_expiry_date: [''],
      permanent_address:[''],
      permanent_address_district:[''],
      permanent_address_state:[''],
      permanent_address_city:[''],
      permanent_address_zipcode:[''],

      father_name:['',Validators.required],
      father_educational_qualification:[''],
      father_occupation:[''],
      father_designation:[''],
      father_working_firm:[''],
      father_working_firm_address:[''],
      father_state_id:[''],
      father_office_no:[''],
      father_telephone_no:[''],
      father_email_id:['',Validators.required],
      father_mobile_no:['',Validators.required],

      mother_name: ['',Validators.required],
      mother_dob: [''],
      mother_educational_qualification: [''],
      mother_occupation: [''],
      mother_designation: [''],
      mother_working_firm: [''],
      mother_working_firm_address: [''],
      mother_state_id: [''],
      mother_office_no: [''],
      mother_telephone_no: [''],
      mother_mobile_no: ['',Validators.required],
      mother_email_id: [''],

      grand_father_name: [''],
      grand_mother_name: [''],
      grand_father_educational_qualification: [''],
      grand_mother_educational_qualification: [''],
      family_image: ['']
    });

  profilepic_size = 0
  errors: string;
  classData :any;
  divisionData : any;
  religionData : any;
  relationData : any;
  nationalityData : any;
  submitted: boolean = false;
  submit:any
  added: boolean = false;
  message: any;
  saveDisable: boolean = false;
  cities: any = [];
  districts: any = [];
  studentFile: File;
  parentFile: File;
  schoolname:any;
  schoolemail:any;
  schoolphone:any;
  schooladdress:any; 
  schoollogo:any;
  schooladdressline:any;
  page_flag = 0
  school:any ;
  genders: string[] = ['Male', 'Female', 'Other'];
  bloodgroups: string[] = ['O-', 'O+', 'A-', 'A+', 'B-', 'B+', 'AB-','AB+'];



  constructor(
    private toastr: ToastrService,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private router: Router,
    private studentsService: StudentsService,
    private districtservice:DistrictService,
    private citytownservice:CitytownService,
    private organizationservice:OrganizationService,
    private classesservice: ClassesService,
    private relationshipService:RelationshipService,
    private religionService:ReligionService,
    private nationalityService:NationalityService) {
  }

  get f() {
    return this.RegistrationForm.controls;
  }

  onSubmit(){
    this.submitted = true;
    if (this.RegistrationForm.invalid) {
      this.toastr.error('Form error..! Please Fill All Mandatory Fields');
      return;
    }
     const date_of_reg = this.RegistrationForm.value.date_of_registration;
     if (date_of_reg) {
           this.RegistrationForm.patchValue({date_of_registration: moment(date_of_reg, 'YYYY-MM-DD').format('YYYY-MM-DD')});
     }     

     const admission_Date = this.RegistrationForm.value.admission_date;
     if (admission_Date) {
           this.RegistrationForm.patchValue({admission_date: moment(admission_Date, 'YYYY-MM-DD').format('YYYY-MM-DD')});
     }     

     const passport_Expiry_Date = this.RegistrationForm.value.passport_expiry_date;
     if (passport_Expiry_Date) {
           this.RegistrationForm.patchValue({passport_expiry_date: moment(passport_Expiry_Date, 'YYYY-MM-DD').format('YYYY-MM-DD')});
     }     

     const passport_Date_Issue = this.RegistrationForm.value.passport_date_of_issue;
     if (passport_Date_Issue) {
           this.RegistrationForm.patchValue({passport_date_of_issue: moment(passport_Date_Issue, 'YYYY-MM-DD').format('YYYY-MM-DD')});
     }                     

     const emirates_Expiry_Date = this.RegistrationForm.value.emirates_expiry_date;
     if (emirates_Expiry_Date) {
           this.RegistrationForm.patchValue({emirates_expiry_date: moment(emirates_Expiry_Date, 'YYYY-MM-DD').format('YYYY-MM-DD')});
     }                     

     const residence_visa_Expiry_Date = this.RegistrationForm.value.residence_visa_expiry_date;
     if (residence_visa_Expiry_Date) {
           this.RegistrationForm.patchValue({residence_visa_expiry_date: moment(residence_visa_Expiry_Date, 'YYYY-MM-DD').format('YYYY-MM-DD')});
     }                     

     const mother_Dob = this.RegistrationForm.value.mother_dob;
     if (mother_Dob) {
           this.RegistrationForm.patchValue({mother_dob: moment(mother_Dob, 'YYYY-MM-DD').format('YYYY-MM-DD')});
     }                     

     const parent_Dob = this.RegistrationForm.value.parent_dob;
     if (parent_Dob) {
           this.RegistrationForm.patchValue({parent_dob: moment(parent_Dob, 'YYYY-MM-DD').format('YYYY-MM-DD')});
     }      
     const student_Dob = this.RegistrationForm.value.student_dob;
     if (student_Dob) {
           this.RegistrationForm.patchValue({student_dob: moment(student_Dob, 'YYYY-MM-DD').format('YYYY-MM-DD')});
     } 

    this.sharedService.postParentAccountForm(this.RegistrationForm.value).subscribe(response => {
      if(this.studentFile) {   
          var uploadData = new FormData();  
          uploadData.append('id',response['id'])
          uploadData.append('type','Student')
          uploadData.append('media',this.studentFile)
          this.sharedService.postImagesParentAccountForm(uploadData).subscribe((response)=>{
             if(response != 'success'){
                 this.toastr.error(response['message'])
             }        
          })
      }
      if(this.parentFile) {   
          var uploadData = new FormData();  
          uploadData.append('id',response['id'])
          uploadData.append('type','Family')
          uploadData.append('media',this.parentFile)
          this.sharedService.postImagesParentAccountForm(uploadData).subscribe((response)=>{
             if(response != 'success'){
                 this.toastr.error(response['message'])
             }         
          })
      } 
      this.toastr.success('Saved Succesfully..!','When your account is activated you will receive an SMS with your username and password!');
      this.router.navigate(['/login'])
      this.added = true;
    }, error => {
      this.submitted = false;
      this.errors = error;
    });

  }

  ngOnInit() {
    this.getschoolname();
    this.getClasses();
    this.getDivisions();

    this.getDistrict();
    this.getCity();
    this.getReligions();
    this.getRelationships();
    this.getNAtionalities();

  }

  onStudentImgChanged(event) {
      this.studentFile = event.target.files[0];
  }

  onParentImgChanged(event) {
      this.parentFile = event.target.files[0];
  }

  getClasses() {
      this.classesservice.getdistinctclasses().subscribe(data => {
      this.classData = data;
      });
  }

  getDivisions(){
     this.classesservice.getdivisions(this.RegistrationForm.value.student_class).subscribe(data => {
     this.divisionData = data;
      });
  } 

  getReligions() {
    this.religionService.getReligions().subscribe((data: any) => {
      this.religionData = data;
    });
  }

 getRelationships() {
    this.relationshipService.getRelationships().subscribe((data: any) => {
      this.relationData = data;
    });
  }

 getNAtionalities() {
    this.nationalityService.getNationalities().subscribe((data: any) => {
      this.nationalityData = data;
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
  }

  checkEmailorContactNumberExist() {
    if (this.RegistrationForm.value.parent_contact_number && this.RegistrationForm.value.parent_email_id) {
      this.sharedService.checkEmailorContactNumberExist(this.RegistrationForm.value.parent_contact_number, this.RegistrationForm.value.parent_email_id).subscribe(data => {
        if (data['status'] == 1) {
          this.message = data['message'];
          if (this.message) {
            this.saveDisable = true;
          } else {
            this.saveDisable = false;
          }
        }
      });
    }
  }

  public getDistrict() {
      this.districtservice.getDistricts().subscribe((data: any) => {
      this.districts = data;
    });
  }

  public getCity() {
       this.citytownservice.getCitytowns().subscribe((data: any) => {
       this.cities = data;
    });
  }


  public getschoolname() {
        this.organizationservice.getactiveorganization().subscribe((data: any) => {
        this.school = data[0];
        this.schoolname = this.school['org_name']
        this.schoolemail = this.school['org_email']
        this.schoolphone = this.school['org_phone']
        this.schooladdress = this.school['org_address_line1']
        this.schooladdressline = this.school['org_address_line2']
        this.schoollogo = this.school['institute_image']

     });
  }

  Nextpagefn(){
    this.page_flag += 1
  }  

  Prevpagefn(){
    this.page_flag -= 1
  }

  firstNextfn(){
    if (!this.RegistrationForm.value.student_fullname ||
       !this.RegistrationForm.value.student_class ||
       !this.RegistrationForm.value.student_division) {
      this.RegistrationForm.markAllAsTouched();
      this.toastr.error('Error!..', 'Please fill Name, Class and Class division..!');
    }
    else{
      this.page_flag += 1
    }  
  }

  thirdNextfn(){
    if (!this.RegistrationForm.value.student_first_name || 
        !this.RegistrationForm.value.date_of_registration || 
        !this.RegistrationForm.value.student_nationality_id ||
        !this.RegistrationForm.value.student_gender || 
        !this.RegistrationForm.value.student_dob || 
        !this.RegistrationForm.value.passport_date_of_issue || 
        !this.RegistrationForm.value.passport_expiry_date || 
        !this.RegistrationForm.value.emirates_expiry_date ||
        !this.RegistrationForm.value.residence_visa_expiry_date) {
      this.RegistrationForm.markAllAsTouched();
      this.toastr.error('Error!..', 'Please fill all mandatory fields..!');
    }
    else{
      this.page_flag += 1
    }  
  }  

  fourthNextfn(){
    if (!this.RegistrationForm.value.father_name || 
        !this.RegistrationForm.value.father_email_id || 
        !this.RegistrationForm.value.father_mobile_no ||
        !this.RegistrationForm.value.mother_name || 
        !this.RegistrationForm.value.mother_mobile_no) {
      this.RegistrationForm.markAllAsTouched();
      this.toastr.error('Error!..', 'Please fill all mandatory fields..!');
    }
    else{
      this.page_flag += 1
    }  
  }   
}
